export const TEST_TYPE_ENUM = {
  survey: 'survey',
  tree_test: 'tree_test',
  cardsort: 'cardsort',
  unmoderated: 'unmoderated',
  moderated: 'moderated',
};

export const QUESTION_TYPE_ENUM = [
  { label: 'Task/Question', key: 'task', icon: '/images/question-task.png' },
  { label: 'URL', key: 'url', icon: '/images/question-url.png' },
  { label: 'Rating', key: 'range', icon: '/images/question-rate.png' },
  { label: 'Written response', key: 'written', icon: '/images/question-written.png' },
  { label: 'Multiple Select (pick any)', key: 'multiple_select', icon: '/images/question-multiple.png' },
  { label: 'Single Select (pick one)', key: 'single_select', icon: '/images/question-single.png' },
  { label: 'Image', key: 'image_select', icon: '/images/question-image.png' },
  { label: 'Audio/Video', key: 'audio_video', icon: '/images/question-video.png' },
];

const SURVEY_FORBIDDEN_TYPES = ['url', 'audio_video'];
export const SURVEY_QUESTION_TYPES = QUESTION_TYPE_ENUM.filter(({ key }) => !(SURVEY_FORBIDDEN_TYPES.includes(key)));

const TREE_TEST_FORBIDDEN_TYPES = ['audio_video', 'image_select', 'url', 'task'];
export const TREE_TEST_QUESTION_TYPES = QUESTION_TYPE_ENUM.filter(({ key }) => !(TREE_TEST_FORBIDDEN_TYPES.includes(key)));

const UNMOD_FORBIDDEN_TYPES = ['audio_video', 'image_select', 'url'];
export const UNMOD_QUESTION_TYPES = QUESTION_TYPE_ENUM.filter(({ key }) => !(UNMOD_FORBIDDEN_TYPES.includes(key)));

export const ACTIVITIES = [
  {
    label: 'First click test',
    key: 'first_click_test',
    icon: '/images/question-first-click-test.png',
  },
  {
    label: 'Five-second test',
    key: 'five_second',
    comingSoon: true,
  },
  {
    label: 'Preference',
    key: 'preference',
    icon: '/images/question-preference.png',
  },
];

export const ASSETS = [
  {
    key: 'url',
    label: 'URL',
    icon: '/images/question-url.png',
  },
  {
    key: 'image_select',
    label: 'Image',
    icon: '/images/question-image.png',
  },
  {
    key: 'audio_video',
    label: 'Audio/Video',
    icon: '/images/question-video.png',
  },
];
